import { createContext, FC, useContext } from "react";

import { DropdownVariant } from "../types";

type DropdownContextType = {
  allowIcons: boolean;
  hasAnyIcons: boolean;
  hasError: boolean;
  hasSelectedOption?: boolean;
  variant: DropdownVariant;
};

const DropdownContext = createContext<DropdownContextType>({
  allowIcons: false,
  hasAnyIcons: false,
  hasError: false,
  hasSelectedOption: undefined,
  variant: "DEFAULT",
});

export const DropdownContextProvider: FC<DropdownContextType> = ({
  children,
  ...rest
}) => (
  <DropdownContext.Provider value={{ ...rest }}>
    {children}
  </DropdownContext.Provider>
);

export const useDropdownContext = () => useContext(DropdownContext);
